import $ from "jquery";
import { Select, Input, Button, Tag } from "antd";
import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import ButtonBar from "../../../core/ButtonBar";
import Table from "../../../core/Table";
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { AppContext } from "../../App/AppContext";

window.$ = $;

const LookupComponent = ({
  title,
  selected,
  onSelect,
  multiple,
  show,
  setShow,
  placeholder,
  disabled,
  required,
  onClear,
  onRemove,
  textRenderer = element => element.name,
  style,
  ...tableProps
}) => {
  const handleClose = () => setShow(false);
  const handleOpen = () => setShow(true);
  const inProgress = useContext(AppContext).promiseInProgress;
  disabled = disabled || inProgress;

  let value = undefined;
  if (selected) {
    if (Array.isArray(selected) && multiple) {
      value = selected.map(s => ({ label: textRenderer(s), value: s }));
    } else {
      value = { label: textRenderer(selected), value: selected };
    }
  }

  const onOpenClick = e => {
    e.preventDefault();
    e.stopPropagation();
    handleOpen();
  };

  const tagRender = ({ label, closable, onClose, value }) => {
    let tagStyle = undefined;
    let tagTextStyle = undefined;
    let tagClass = "tag-close-multiple";
    let tagTextClass = undefined;

    if (!multiple) {
      const maxWidth = $(".ant-select-selector").first().width();
      tagStyle = {
        maxWidth: `${maxWidth - 20}px`
      };
      tagTextStyle = { maxWidth: `${maxWidth - 60}px` };
      tagClass = "tag-close";
      tagTextClass = "tag-text";
    }

    return (
      <Tag
        key={value.id}
        closable={!disabled && closable}
        onClose={!disabled && onClose}
        className={tagClass}
        style={tagStyle}
      >
        <span className={tagTextClass} style={tagTextStyle}>
          {label}
        </span>
      </Tag>
    );
  };

  const className = `lookup ${
    required && value ? "valid" : required && !value ? "error" : "normal"
  }`;
  let selectClassName = "search-class-horizontal";
  if (disabled) {
    selectClassName = `${selectClassName} lookup-search-disabled`;
  }

  const onClearClick = e => {
    e.preventDefault();
    e.stopPropagation();
    onClear();
  };

  return (
    <>
      <Input.Group compact className={`d-flex ${className}`}>
        <div className="flex-grow-1">
          <Select
            labelInValue
            mode="multiple"
            onClick={!disabled && onOpenClick}
            open={false}
            className={selectClassName}
            allowClear={!disabled && multiple}
            value={value}
            clearIcon={<CloseCircleOutlined onClick={onClearClick} />}
            onClear={!disabled && onClearClick}
            onDeselect={deselected => onRemove(deselected.value)}
            tagRender={tagRender}
            placeholder={placeholder}
            disabled={disabled}
            style={{ ...style }}
          />
        </div>

        <Button
          type="primary"
          icon={<SearchOutlined />}
          className="search-group-button"
          onClick={onOpenClick}
          disabled={disabled}
        />
      </Input.Group>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table {...tableProps} />
        </Modal.Body>
        <Modal.Footer>
          <ButtonBar
            affix={false}
            onClose={handleClose}
            onSave={multiple && onSelect}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LookupComponent;
